export default __webpack_public_path__ + "static/media/gamification.07f14d2d.svg";